export default "__VITE_ASSET__CSnY7qCy__";